import {
  Box,
  Card,
  Checkbox,
  InputAdornment,
  ListItem,
  ListItemText,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SelectMaterial from "./SelectMaterial";
import { useTheme } from "@emotion/react";

const MaterialSection = ({ quote, onUpdateQuote, defaultVariables }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  const onUpdateIsTollFormOrder = (isTollForm) => {
    // isTollForm combines isCustomerSupplied and isCustomMaterial

    if (isTollForm) {
      // IF Switching to Toll Form,
      // - remove variables.extra_flats
      // - remove variables.other_fs_cost
      // - set GP to 0% (this is causing infinite reload)
      let quoteItemsCopy = [...quote.items];
      for (let item of quoteItemsCopy) {
        if (item.variables) {
          item.variables.extra_flats = 0;
          item.variables.other_fs_cost = 0;
          // item.gross_profit_margin = 0;
        }
      }

      let update = {
        isTollForm: isTollForm,
        isCustomMaterial: isTollForm,
        isMaterialSuppliedByCustomer: isTollForm,
        manufacturer: null,
        color: null,
        gauge: null,
        // Regular Material Rates
        flatSheetCost: 0,
        flatSheetCostOriginal: 0,
        coilCostPerSqFt: 0,
        coilCostPerSqFtOriginal: 0,
        flatSheetSize: 48,

        // Toll Form Rates
        tollFormPricePerHit: 2.5, // Default $2.50
        tollFormPanelRunFeePerLF: 2.5, // Default $2.50

        // Cleanup Item Variables
        items: quoteItemsCopy,
      };
      onUpdateQuote(update);
    } else {
      // IF Switching to Single Bill,
      // - remove variables.extra_flats
      // - remove variables.other_fs_cost
      // - reset default GP % (this is causing infinite reload)
      let quoteItemsCopy = [...quote.items];
      for (let item of quoteItemsCopy) {
        if (item.variables) {
          item.variables.extra_flats = 0;
          item.variables.other_fs_cost = 0;
          // item.gross_profit_margin = defaultVariables.gross_profit_margin;
        }
      }
      let update = {
        isTollForm: isTollForm,
        isCustomMaterial: isTollForm,
        isMaterialSuppliedByCustomer: isTollForm,

        customColor: null,
        customGauge: null,
        customManufacturer: null,
        // Regular Material Rates
        flatSheetCost: 0,
        flatSheetCostOriginal: 0,
        coilCostPerSqFt: 0,
        coilCostPerSqFtOriginal: 0,
        flatSheetSize: 48,

        // Toll Form Rates
        tollFormPricePerHit: 0,
        tollFormPanelRunFeePerLF: 0,

        // Cleanup Item Variables
        items: quoteItemsCopy,
      };
      onUpdateQuote(update);
    }
  };

  const onUpdateIsCustomMaterial = (isCustomMaterial) => {
    if (isCustomMaterial) {
      let update = {
        isCustomMaterial: isCustomMaterial,

        manufacturer: null,
        color: null,
        gauge: null,
        flatSheetCost: 0,
        flatSheetCostOriginal: 0,
        coilCostPerSqFt: 0,
        coilCostPerSqFtOriginal: 0,
        flatSheetSize: 48,
      };
      onUpdateQuote(update);
    } else {
      let update = {
        isTollForm: false, // If fakse, set isTollForm to false
        isCustomMaterial: isCustomMaterial,
        customColor: null,
        customGauge: null,
        customManufacturer: null,
        flatSheetCost: 0,
        flatSheetCostOriginal: 0,
        coilCostPerSqFt: 0,
        coilCostPerSqFtOriginal: 0,
        flatSheetSize: 48,
      };
      onUpdateQuote(update);
    }
  };

  const onUpdateIsCustomerSupplied = (isCustomerSupplied) => {
    if (isCustomerSupplied) {
      // If Customer supplied, set all material cost to zero
      let update = {
        isMaterialSuppliedByCustomer: isCustomerSupplied,
        flatSheetCost: 0,
        flatSheetCostOriginal: 0,
        coilCostPerSqFt: 0,
        coilCostPerSqFtOriginal: 0,
      };
      onUpdateQuote(update);
    } else {
      let update = {
        isMaterialSuppliedByCustomer: isCustomerSupplied,
        isTollForm: false, // If fakse, set isTollForm to false
      };
      onUpdateQuote(update);
    }
  };

  if (quote)
    return (
      <Box>
        <Typography variant="h6">Materials</Typography>
        <Box sx={{}}>
          <Box>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                magin: 0,
                padding: 0,
                marginRight: "16px",
              }}
            >
              <Checkbox
                style={{
                  magin: 0,
                  padding: 0,
                }}
                checked={quote.isTollForm == true}
                onChange={(e) => {
                  onUpdateIsTollFormOrder(e.target.checked);
                }}
              />
              <Typography>Toll-Form Order</Typography>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                magin: 0,
                padding: 0,
              }}
            >
              <Checkbox
                style={{
                  magin: 0,
                  padding: 0,
                }}
                checked={quote.isCustomMaterial == true}
                onChange={(e) => {
                  onUpdateIsCustomMaterial(e.target.checked);
                }}
              />
              <Typography>Custom Material</Typography>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                magin: 0,
                padding: 0,
                marginRight: "16px",
              }}
            >
              <Checkbox
                style={{
                  magin: 0,
                  padding: 0,
                }}
                checked={quote.isMaterialSuppliedByCustomer == true}
                onChange={(e) => {
                  onUpdateIsCustomerSupplied(e.target.checked);
                }}
              />
              <Typography>FS and Coil Supplied by Customer</Typography>
            </div>
          </Box>
          {quote.isCustomMaterial ? (
            <Box
              sx={{ display: "flex", flexDirection: "row", marginTop: "16px" }}
            >
              <Box sx={{ display: "flex", flexDirection: "row", gap: "1rem" }}>
                <TextField
                  variant="outlined"
                  label="Color"
                  name="Color"
                  size="small"
                  fullWidth
                  value={quote.customColor ? quote.customColor : ""}
                  onChange={(e) => {
                    let update = {
                      customColor: e.target.value,
                    };
                    onUpdateQuote(update);
                  }}
                />
                <TextField
                  variant="outlined"
                  label="Manufacturer"
                  name="Manufacturer"
                  size="small"
                  fullWidth
                  value={
                    quote.customManufacturer ? quote.customManufacturer : ""
                  }
                  onChange={(e) => {
                    let update = {
                      customManufacturer: e.target.value,
                    };
                    onUpdateQuote(update);
                  }}
                />
                <TextField
                  variant="outlined"
                  label="Gauge"
                  name="Gauge"
                  size="small"
                  fullWidth
                  value={quote.customGauge ? quote.customGauge : ""}
                  onChange={(e) => {
                    let update = {
                      customGauge: e.target.value,
                    };
                    onUpdateQuote(update);
                  }}
                />
                <TextField
                  variant="outlined"
                  label="Material Width"
                  name="Material Width"
                  size="small"
                  fullWidth
                  value={quote.flatSheetSize ? quote.flatSheetSize : ""}
                  onChange={(e) => {
                    let update = {
                      flatSheetSize: e.target.value,
                    };
                    onUpdateQuote(update);
                  }}
                />
              </Box>
            </Box>
          ) : (
            <SelectMaterial quote={quote} onUpdateQuote={onUpdateQuote} />
          )}
          <Box>
            {quote.isTollForm ? (
              <TextField
                size="small"
                sx={{ marginTop: "16px", marginRight: "8px" }}
                onFocus={(e) => e.target.select()}
                label="Price Per Hit"
                type="number"
                value={`${quote?.tollFormPricePerHit}`}
                onChange={(e) => {
                  let update = {
                    tollFormPricePerHit: parseFloat(e.target.value),
                  };
                  onUpdateQuote(update);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            ) : (
              <TextField
                size="small"
                sx={{ marginTop: "16px", marginRight: "8px" }}
                onFocus={(e) => e.target.select()}
                label="FS Price"
                type="number"
                value={`${quote?.flatSheetCost}`}
                onChange={(e) => {
                  let update = {
                    flatSheetCost: parseFloat(e.target.value),
                  };
                  onUpdateQuote(update);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            )}

            {quote.isTollForm ? (
              <TextField
                size="small"
                sx={{ marginTop: "16px" }}
                onFocus={(e) => e.target.select()}
                label="Panel Run Fee Per LF"
                type="number"
                value={`${quote?.tollFormPanelRunFeePerLF}`}
                onChange={(e) => {
                  let update = {
                    tollFormPanelRunFeePerLF: parseFloat(e.target.value),
                  };
                  onUpdateQuote(update);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            ) : (
              <TextField
                size="small"
                sx={{ marginTop: "16px" }}
                onFocus={(e) => e.target.select()}
                label="Coil Price Per Sq Ft"
                type="number"
                value={`${quote?.coilCostPerSqFt}`}
                onChange={(e) => {
                  let update = {
                    coilCostPerSqFt: parseFloat(e.target.value),
                  };
                  onUpdateQuote(update);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="Start"
                      sx={{ marginRight: "4px" }}
                    >
                      $
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </Box>
        </Box>
      </Box>
    );
};

export default MaterialSection;
